import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-scan-error',
  templateUrl: './scan-error.component.html',
  styleUrls: ['./scan-error.component.scss'],
  standalone: false,
})
export class ScanErrorComponent {
  @Input() message: string;
}
